import { Link } from "react-router-dom";

export default function StoreCancel() {
  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--text)] flex items-center justify-center px-6 text-center">
      <div data-testid="store-cancel-page" className="max-w-md">
        <div className="text-xs uppercase tracking-[0.4em] text-zinc-500 mb-3">No charge</div>
        <h1 className="text-3xl font-black">No worries.</h1>
        <p className="mt-3 text-zinc-400">Your support means the world even without it.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/store" data-testid="store-cancel-retry" className="px-5 py-2 rounded-full bg-[var(--accent)] text-black font-bold text-sm">Try again</Link>
          <Link to="/dashboard" data-testid="store-cancel-home" className="px-5 py-2 rounded-full border border-white/15 text-sm">Dashboard</Link>
        </div>
      </div>
    </div>
  );
}
